import stateManager from "../data/state_manager.js";
export function isDan() {
  const user = (stateManager.getState().serverside_user || {}).username || '';
  return user.toLowerCase() === 'dan';
}
